export default {"src":"/_next/static/media/0xda10009cbd5d07dd0cecc66161fc93d7c9000da1.ccfaf818.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};